'use client';

import { useEffect } from 'react';
import { cargarAnaliticaGoogle, instalarGuardiaAnaliticaApp } from '@/lib/analitica/analiticaGoogle';

// Same timing as next/script's lazyOnload (after window load, when the browser is idle), but the
// load checks the path at the moment it runs: a lazy load scheduled on a marketing page must not
// fire after the user has already moved into /app (02-REVIEW CR-05).
function alQuedarInactivo(tarea: () => void): void {
    if (typeof window.requestIdleCallback === 'function') window.requestIdleCallback(tarea);
    else window.setTimeout(tarea, 1);
}

export function programarCargaAnalitica(): () => void {
    const cargar = () => alQuedarInactivo(cargarAnaliticaGoogle);
    if (document.readyState === 'complete') {
        cargar();
        return () => undefined;
    }
    window.addEventListener('load', cargar, { once: true });
    return () => window.removeEventListener('load', cargar);
}

export default function AnaliticaGoogle() {
    useEffect(() => {
        instalarGuardiaAnaliticaApp();
        return programarCargaAnalitica();
    }, []);
    return null;
}
